import { ProductoData } from './ProductoData';

export class ResultadoData {
  products: ProductoData[];
  title: string;
  icon: string;
  comments: string;

  constructor(products: ProductoData[], title: string, icon: string, comments: string) {
    this.title = title;
    this.icon = icon;
    this.comments = comments;
    this.products = products;
  }
}
